var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpireToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 354.604,
    height: 73.999,
    viewBox: "0 0 354.604 73.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.182,
    y1: 7.581,
    x2: 0.408,
    y2: 1.884,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#875fea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18e9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.404,
    y1: 2.023,
    x2: 0.573,
    y2: 0.232,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.356,
    y1: 0.948,
    x2: 0.635,
    y2: -0.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.273,
    y1: 1.378,
    x2: 0.592,
    y2: 0.138,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279",
    transform: "translate(-1003.673 -1395.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2",
    transform: "translate(1003.673 1395.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M1094.571,1395.778h-25.649l-5.443,9.328,36.523.06Z",
    transform: "translate(-1030.314 -1395.778)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M1041.441,1395.778h-9.425l-12.644,21.852,5.182,8Z",
    transform: "translate(-1010.666 -1395.778)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M1051.969,1477h13.059l-3.524,6.426h-30.885l-21.69-37.468-5.257,9.278,21.35,36.9h42.907l13.106-23.008h-33.212Z",
    transform: "translate(-1003.673 -1418.131)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M1091.549,1424.187h-43.541l-11.815,21.35,12.437,21.765h9.949l-12.022-21.557,7.462-13.266h31.714l5.182,8.706h-32.75l-2.073,4.353,2.073,3.938h42.291l3.31-3.938Z",
    transform: "translate(-1018.159 -1408.433)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_279-2",
    "data-name": "Group 279",
    transform: "translate(1104.376 1419.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M1189.076,1458.232v1.527a1.831,1.831,0,0,0,1.138,1.542,7.767,7.767,0,0,0,3.653.644h3.443q.689,0,.883.374a2.515,2.515,0,0,1,.2,1.124,2.607,2.607,0,0,1-.2,1.137q-.194.39-.883.39h-3.563q-8.475,0-8.475-5.211v-6.5q0-5.21,8.475-5.21h6.917q4.493,0,6.484,1.287a4.353,4.353,0,0,1,1.991,3.923v3.444a1.687,1.687,0,0,1-.329,1.2,2.209,2.209,0,0,1-1.468.329Zm0-2.965h16.26v-2.006a1.767,1.767,0,0,0-1.123-1.617,8.666,8.666,0,0,0-3.668-.568h-6.678a7.934,7.934,0,0,0-3.653.629,1.816,1.816,0,0,0-1.138,1.557Z",
    transform: "translate(-1185.272 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M1262.916,1465.089a3.016,3.016,0,0,1-1.437-.269,1.194,1.194,0,0,1-.479-1.138v-10.421a1.821,1.821,0,0,0-1.018-1.557,7.162,7.162,0,0,0-3.533-.629h-1.677a10.9,10.9,0,0,0-2.081.165,4.3,4.3,0,0,0-1.332.464,1.806,1.806,0,0,0-.719.7,1.831,1.831,0,0,0-.209.854v10.421a1.2,1.2,0,0,1-.479,1.138,3.018,3.018,0,0,1-1.438.269,2.646,2.646,0,0,1-1.452-.3,1.253,1.253,0,0,1-.434-1.108v-10.421a1.839,1.839,0,0,0-.209-.854,1.817,1.817,0,0,0-.719-.7,4.317,4.317,0,0,0-1.333-.464,10.9,10.9,0,0,0-2.081-.165h-1.677a7.162,7.162,0,0,0-3.534.629,1.821,1.821,0,0,0-1.018,1.557v10.421a1.2,1.2,0,0,1-.479,1.138,3.019,3.019,0,0,1-1.438.269,2.921,2.921,0,0,1-1.422-.269,1.209,1.209,0,0,1-.464-1.138v-10.421a4.334,4.334,0,0,1,2.021-3.923,10.552,10.552,0,0,1,5.675-1.287h2.964q3.773,0,5.6,1.5,1.857-1.5,5.63-1.5h2.964a10.551,10.551,0,0,1,5.675,1.287,4.334,4.334,0,0,1,2.021,3.923v10.421a1.21,1.21,0,0,1-.464,1.138A2.924,2.924,0,0,1,1262.916,1465.089Z",
    transform: "translate(-1206.2 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M1299.4,1468.593a1.194,1.194,0,0,1-.479,1.137,3.008,3.008,0,0,1-1.438.27,2.907,2.907,0,0,1-1.422-.27,1.207,1.207,0,0,1-.464-1.137v-15.332q0-5.21,8.474-5.21h7.187q8.472,0,8.474,5.21v6.5q0,5.211-8.474,5.211H1299.4Zm11.738-6.648a7.935,7.935,0,0,0,3.653-.628,1.818,1.818,0,0,0,1.139-1.558v-6.5a1.833,1.833,0,0,0-1.139-1.542,7.77,7.77,0,0,0-3.653-.644h-6.947a7.771,7.771,0,0,0-3.653.644,1.832,1.832,0,0,0-1.138,1.542v8.684Z",
    transform: "translate(-1234.417 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M1342.843,1441.051a1.705,1.705,0,0,1,.554-1.407,3.874,3.874,0,0,1,3.623,0,2.064,2.064,0,0,1,0,2.814,3.874,3.874,0,0,1-3.623,0A1.7,1.7,0,0,1,1342.843,1441.051Zm4.282,18.685a1.2,1.2,0,0,1-.479,1.138,3.019,3.019,0,0,1-1.437.269,2.924,2.924,0,0,1-1.422-.269,1.209,1.209,0,0,1-.464-1.138V1445.6a1.209,1.209,0,0,1,.464-1.138,2.922,2.922,0,0,1,1.422-.269,3.018,3.018,0,0,1,1.437.269,1.2,1.2,0,0,1,.479,1.138Z",
    transform: "translate(-1255.464 -1439.194)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M1365.516,1448.051q.688,0,.884.389a2.627,2.627,0,0,1,.194,1.138,2.52,2.52,0,0,1-.194,1.122q-.2.375-.884.375h-2.336a6,6,0,0,0-3.084.568,1.8,1.8,0,0,0-.869,1.588v10.45a1.2,1.2,0,0,1-.479,1.138,3.019,3.019,0,0,1-1.438.269,2.92,2.92,0,0,1-1.422-.269,1.209,1.209,0,0,1-.464-1.138v-10.45a4.322,4.322,0,0,1,1.991-3.893,10.656,10.656,0,0,1,5.764-1.287Z",
    transform: "translate(-1261.069 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M1381.691,1458.232v1.527a1.832,1.832,0,0,0,1.138,1.542,7.767,7.767,0,0,0,3.653.644h3.444q.689,0,.883.374a2.515,2.515,0,0,1,.2,1.124,2.607,2.607,0,0,1-.2,1.137q-.195.39-.883.39h-3.563q-8.475,0-8.474-5.211v-6.5q0-5.21,8.474-5.21h6.917q4.492,0,6.483,1.287a4.352,4.352,0,0,1,1.991,3.923v3.444a1.684,1.684,0,0,1-.329,1.2,2.207,2.207,0,0,1-1.467.329Zm0-2.965h16.26v-2.006a1.766,1.766,0,0,0-1.123-1.617,8.665,8.665,0,0,0-3.668-.568h-6.678a7.935,7.935,0,0,0-3.653.629,1.817,1.817,0,0,0-1.138,1.557Z",
    transform: "translate(-1271.076 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M1444.824,1444.105v-3.5a1.208,1.208,0,0,1,.464-1.137,2.912,2.912,0,0,1,1.423-.27,3,3,0,0,1,1.437.27,1.194,1.194,0,0,1,.479,1.137v3.5h6.318q.689,0,.883.389a2.613,2.613,0,0,1,.2,1.138,2.505,2.505,0,0,1-.2,1.122q-.194.375-.883.375h-6.318v12.606a1.2,1.2,0,0,1-.479,1.138,3.02,3.02,0,0,1-1.437.269,2.928,2.928,0,0,1-1.423-.269,1.21,1.21,0,0,1-.464-1.138V1447.13h-1.708q-.688,0-.883-.375a2.506,2.506,0,0,1-.195-1.122,2.614,2.614,0,0,1,.195-1.138q.194-.389.883-.389Z",
    transform: "translate(-1299.653 -1439.194)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M1469.038,1453.261q0-5.21,8.474-5.21h6.529q8.473,0,8.474,5.21v6.5q0,5.211-8.474,5.211h-6.529q-8.474,0-8.474-5.211Zm19.674,0a1.817,1.817,0,0,0-1.138-1.557,7.935,7.935,0,0,0-3.653-.629h-6.288a7.934,7.934,0,0,0-3.653.629,1.817,1.817,0,0,0-1.138,1.557v6.5a1.832,1.832,0,0,0,1.138,1.542,7.766,7.766,0,0,0,3.653.644h6.288a7.767,7.767,0,0,0,3.653-.644,1.833,1.833,0,0,0,1.138-1.542Z",
    transform: "translate(-1311.68 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M1519.767,1450.783l12.277-6.468a2.485,2.485,0,0,1,.883-.27,12.83,12.83,0,0,1,1.422-.059,1.917,1.917,0,0,1,1.033.269.919.919,0,0,1,.435.839.893.893,0,0,1-.24.659,2.255,2.255,0,0,1-.6.419l-12.038,6.319,12.247,6.2a1.381,1.381,0,0,1,.869,1.257.959.959,0,0,1-.524.929,3.573,3.573,0,0,1-1.573.269,6.037,6.037,0,0,1-1.512-.149,3.151,3.151,0,0,1-.793-.3l-11.888-6.289v5.33a1.2,1.2,0,0,1-.479,1.138,3.019,3.019,0,0,1-1.437.269,2.922,2.922,0,0,1-1.422-.269,1.209,1.209,0,0,1-.464-1.138V1440.6a1.207,1.207,0,0,1,.464-1.137,2.906,2.906,0,0,1,1.422-.27,3,3,0,0,1,1.437.27,1.194,1.194,0,0,1,.479,1.137Z",
    transform: "translate(-1332.584 -1439.194)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M1557.622,1458.232v1.527a1.831,1.831,0,0,0,1.138,1.542,7.764,7.764,0,0,0,3.653.644h3.444q.689,0,.883.374a2.514,2.514,0,0,1,.2,1.124,2.606,2.606,0,0,1-.2,1.137q-.195.39-.883.39h-3.563q-8.475,0-8.475-5.211v-6.5q0-5.21,8.475-5.21h6.917q4.492,0,6.484,1.287a4.352,4.352,0,0,1,1.991,3.923v3.444a1.687,1.687,0,0,1-.329,1.2,2.21,2.21,0,0,1-1.468.329Zm0-2.965h16.26v-2.006a1.767,1.767,0,0,0-1.123-1.617,8.667,8.667,0,0,0-3.669-.568h-6.678a7.932,7.932,0,0,0-3.653.629,1.815,1.815,0,0,0-1.138,1.557Z",
    transform: "translate(-1349.446 -1443.14)",
    fill: "#18e9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M1602.685,1465.089a2.92,2.92,0,0,1-1.422-.269,1.209,1.209,0,0,1-.464-1.138v-10.421q0-5.21,8.474-5.21h6.529q8.474,0,8.475,5.21v10.421a1.2,1.2,0,0,1-.479,1.138,3.02,3.02,0,0,1-1.437.269,2.926,2.926,0,0,1-1.423-.269,1.21,1.21,0,0,1-.464-1.138v-10.421a1.817,1.817,0,0,0-1.137-1.557,7.938,7.938,0,0,0-3.654-.629h-6.288a7.929,7.929,0,0,0-3.653.629,1.816,1.816,0,0,0-1.139,1.557v10.421a1.2,1.2,0,0,1-.479,1.138A3.019,3.019,0,0,1,1602.685,1465.089Z",
    transform: "translate(-1370.375 -1443.14)",
    fill: "#18e9d9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpireToken);
export default __webpack_public_path__ + "static/media/empireToken.9ba2e484a83ce2367b91a668901a0e8e.svg";
export { ForwardRef as ReactComponent };